import * as XLSX from "xlsx";
import { toast } from "react-toastify";
export const exportToExcel = (data, filename) => {
  if (!data || !Array.isArray(data)) {
    return toast.error("Something went wrong", {
      position: toast.POSITION.TOP_RIGHT,
    });
  }
  const ws = XLSX.utils.json_to_sheet(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
  XLSX.writeFile(wb, `${filename}.xlsx`);
};

export function generateRandomString() {
  const characters =
    "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let randomString = "";

  for (let i = 0; i < 6; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    randomString += characters.charAt(randomIndex);
  }

  return randomString;
}

const formatReadableTime = (timeString) => {
  if (!timeString || typeof timeString !== "string" || !timeString.includes(":")) {
    return "0 minutes";
  }

  let [hours, minutes, seconds] = timeString.split(":").map(Number);

  if (seconds > 0 && minutes === 0) minutes = 1;

  let result = [];
  
  if (hours > 0) result.push(`${hours} hour${hours > 1 ? "s" : ""}`);
  
  if (minutes > 0) result.push(`${minutes} minute${minutes > 1 ? "s" : ""}`);

  return result.length ? result.join(" ") : "0 minutes";
};

export default function getStatementFromType(item) {
  let types = [

    // Assignment
    { "assignment_added": `Assigned the Task to ${item?.project_task_assignment?.employee?.first_name + " " + item?.project_task_assignment?.employee?.last_name} ` },
    { "assignment_deleted": `removed ${item?.project_task_assignment?.employee?.first_name + " " + item?.project_task_assignment?.employee?.last_name} from the Task` },

    // Labels
    { "label_added": `added a label to the Task` },
    { "label_updated": `updated a label on the Task` },

    { "label_in_use": `used label ${item?.task_label?.title} for the Task` },
    { "label_not_in_use": `removed a label from the Task` },
    
    { "label_deleted": `deleted a label from the Task` },

    // Priority
    { "priority_added": `added a priority to the Task` },
    { "priority_updated": `updated the priority of the Task` },
    { "priority_deleted": `removed the priority from the Task` },

    // Comments
    { "comment_added": `added a comment to the Task` },
    { "comment_updated": `updated a comment on the Task` },
    { "comment_deleted": `deleted a comment from the Task` },
    
    // Tasks
    { "task_added": `added a new Task` },
    { "task_priority_updated": `updated the Task priority to ${item?.task_priority?.title}` },
    { "task_description_updated": `updated the Task description.` },
    { "task_updated": `updated the Task` },
    { "task_deleted": `deleted the Task` },
    { "task_archived": `archived the Task` },
    { "task_unarchived": `unarchived the Task` },

    // upload attachment
    {"attchment_uploaded":`attchment added ${item?.attachment_name || ""}`},
    {"attchment_deleted":`attchment deleted ${item?.attachment_name}`},

    // Boards
    { "board_added": `created a new Board` },
    { "board_updated": `updated the Board` },
    { "board_deleted": `deleted the Board` },
    
    // DND
    { "task_moved": `moved the Task from ${item?.Board?.title} to ${item?.newBoard?.title}` },
    { "board_moved": `moved the Board` },
    
    // task member time tracked 
    {"task_member_time_tracked": `has logged ${formatReadableTime(item?.task_time?.split(' ')[1]) || 'N/A'} on this task.`}

];

  const typeObject = types.find(type => Object.keys(type)[0] === item.type);

  // If task_moved on the same Board
  if (item.type === 'task_moved' && item.board_id === item.new_board_id) {
    return `moved the Task from position ${item.prev_index} to ${item.new_index} on board ${item?.Board?.title}`;
  }

  return typeObject ? typeObject[item.type] : "";

}

export function getElapsedFormattedTime() {
    const start = localStorage.getItem("taskStart");
    const pausedDuration = parseInt(
      localStorage.getItem("pausedDuration") || "0",
      10
    );
    // const pausedAt = parseInt(localStorage.getItem("pausedAt") || "0", 10);
    if (!start) return "00:00:00";
    let now = Date.now();
    const elapsed = now - parseInt(start) - pausedDuration;
    const totalSeconds = Math.floor(elapsed / 1000);

    const hours = Math.floor(totalSeconds / 3600)
      .toString()
      .padStart(2, "0");
    const minutes = Math.floor((totalSeconds % 3600) / 60)
      .toString()
      .padStart(2, "0");
    const seconds = (totalSeconds % 60).toString().padStart(2, "0");

    const today = new Date();
    const year = today.getFullYear();
    const month = (today.getMonth() + 1).toString().padStart(2, "0");
    const day = today.getDate().toString().padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }